import { Link as RouterLink } from "react-router-dom";
import { Alert, Link } from "@mui/material";
import { ContentContainer } from "components";
import { ROUTE_MATERIALS } from "const";

const NotFound = () => {
  return (
    <ContentContainer py={4}>
      <Alert severity="error" sx={{ mb: 3 }}>
        {/* TODO: Localize */}
        Material not found.
        <br />
        <Link
          to={ROUTE_MATERIALS}
          component={RouterLink}
        >
          {/* TODO: Localize */}
          All Materials
        </Link>
      </Alert>

    </ContentContainer>
  );
};

export default NotFound;
